export default "/images/vendor/flag-icon-css/flags/1x1/mz.svg?dcf8977ee74002921810a1e8014a57a1";